import type { LessonMaterialFragment } from '../../../../shared/lesson-materials/lesson-material-fragment.generated';

export const NUMBER_OF_ITEMS_FIELD = 'numberOfItems';
export const NUMBER_IN_GROUP_FIELD = 'numberInGroup';
export const MATERIAL_FIELD = 'materialField';
export const ALTERNATE_MATERIAL_FIELD = 'alternateMaterialField';
export const OPTIONAL_MATERIAL_FIELD = 'optionalMaterialField';
export const NOTE_FIELD = 'noteField';
export const GROUP_TYPE_FIELD = 'groupTypeField';
export const UNIT_OF_MEASUREMENT_FIELD = 'unitOfMeasurementField';

export const MIN_NUMBER = 1;
export const MAX_NUMBER_IN_GROUP = 99;
export const MAX_NUMBER_OF_ITEMS = 999;

export type FormData = {
  [GROUP_TYPE_FIELD]: string;
  [MATERIAL_FIELD]: number | null;
  [NUMBER_OF_ITEMS_FIELD]: number;
  [NUMBER_IN_GROUP_FIELD]?: number | null;
  [OPTIONAL_MATERIAL_FIELD]: boolean;
  [ALTERNATE_MATERIAL_FIELD]: number[] | null;
  [NOTE_FIELD]?: string | null;
  [UNIT_OF_MEASUREMENT_FIELD]?: number | null;
};

export const ERROR_NUMBER_OF_ITEMS_ID = 'error-number-of-items';
export const ERROR_NUMBER_IN_GROUP_ID = 'error-number-in-group';

export type MaterialItem = {
  isEditMode: boolean;
} & LessonMaterialFragment;
